import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';
const initialData = {
  separateStatementData: {},
  separateStatementStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'separateStatement',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSeparateStatementData: (state, action) => {
      state.separateStatementData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postSeparateStatementData: (state, action) => {
      state.separateStatementStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetSeparateStatement: (state) => {
      state.separateStatementStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchSeparateStatementData,
  resetMsg,
  postSeparateStatementData,
  fetchStart,
  resetSeparateStatement,
  fetchError,
} = slice.actions;

export const fetchSeparateStatement = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/statesettings/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchSeparateStatementData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postSeparateStatement = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/statesettings`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSeparateStatementData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetSeparateStatement());
  };
};
